/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  GetApiV1SerievideoVideoidLangsAvailableLanguages401,
  GetApiV1SerievideoVideoidLangsAvailableLanguages404,
  GetApiV1SerievideoVideoidLangsAvailableLanguages500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsAvailableLanguages.ts";

function getGetApiV1SerievideoVideoidLangsAvailableLanguagesUrl(
  videoId: GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams["videoId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serievideo/${videoId}/langs/available-languages` as const,
  };
  return res;
}

/**
 * @description Retorna os idiomas ainda não cadastrados para o vídeo, para dropdown. **(Requer Authorization para autenticação)**
 * @summary Idiomas disponíveis do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/available-languages}
 */
export async function getApiV1SerievideoVideoidLangsAvailableLanguages(
  videoId: GetApiV1SerievideoVideoidLangsAvailableLanguagesPathParams["videoId"],
  params?: GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerievideoVideoidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsAvailableLanguages401
      | GetApiV1SerievideoVideoidLangsAvailableLanguages404
      | GetApiV1SerievideoVideoidLangsAvailableLanguages500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerievideoVideoidLangsAvailableLanguagesUrl(
      videoId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
